import { SvgIconProps, SxProps, useTheme } from '@mui/material';
import React, { useCallback, useMemo } from 'react';

import { ListItemButton, ListItemStartIcon, ListItemText, Paper } from '@ocx/ui';
import { MapMarkerIcon } from '@ocx/ui-icons';

import { ListItem } from './local-offers-location-selector.types';

type LocalOffersLocationListItemProps = {
  item: ListItem;
  onClick: (item: ListItem) => void;
  Icon?: React.ComponentType<SvgIconProps>;
};

export const LocalOffersLocationListItem = (props: LocalOffersLocationListItemProps) => {
  const theme = useTheme();
  const defaultIconProps: SxProps = useMemo(
    () => ({
      color: theme.palette.text.disabled,
    }),
    [theme.palette.text.disabled],
  );

  const handleOnClick = useCallback(() => {
    props.onClick(props.item);
  }, [props]);

  return (
    <Paper p={0} overflow="hidden">
      <ListItemButton fullWidth onClick={handleOnClick}>
        <ListItemStartIcon>
          {props.Icon ? <props.Icon sx={defaultIconProps} /> : <MapMarkerIcon sx={defaultIconProps} />}
        </ListItemStartIcon>

        <ListItemText primaryVariant="subtitle1" secondary={props.item.subtitle} secondaryColor="text.disabled">
          {props.item.title}
        </ListItemText>
      </ListItemButton>
    </Paper>
  );
};
